module.exports = __webpack_public_path__ + "static/media/index_04.28aebbb5.png";